export {
  formatForContext,
  formatMultiplier,
  formatNumber,
  formatPercent,
  getCurrentNotation,
  isNotation,
  resolvePolicy,
  setCurrentNotation,
  STANDARD_SUFFIX_SCIENTIFIC_FALLBACK_THRESHOLD,
  type FormatContextId,
  type Notation,
  type NumberFormatPolicy,
} from "@/shared/format/numberFormat";

import {
  formatDecimal,
  formatInteger as formatLocaleInteger,
} from "@/i18n/runtime";
import {
  formatNumber,
  STANDARD_SUFFIX_SCIENTIFIC_FALLBACK_THRESHOLD,
  type NumberFormatPolicy,
} from "@/shared/format/numberFormat";

const HUGE_NUMBER_DECIMAL_FALLBACK_POLICY: NumberFormatPolicy = {
  notation: "scientific",
  compactThreshold: 0,
  decimals: 2,
  trimTrailingZeros: true,
  mantissaStepped: false,
  localeFallbackStepped: false,
};

export function formatInteger(value: number): string {
  return formatLocaleInteger(value);
}

export function formatOneDecimal(value: number): string {
  if (
    Number.isFinite(value) &&
    Math.abs(value) >= STANDARD_SUFFIX_SCIENTIFIC_FALLBACK_THRESHOLD
  ) {
    return formatNumber(value, HUGE_NUMBER_DECIMAL_FALLBACK_POLICY);
  }
  return formatDecimal(value, 1);
}

export function formatTwoDecimals(value: number): string {
  return formatDecimal(value, 2);
}
